import {
  faHouse,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";

const orgId: number = 1275652438;
const subDomain: string = "fcm";
const nameOfProduct: string = "FM";
const secureRouteGroups: string[] = ["FCM"];

export const fcmObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to={`/${subDomain}`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHouse} />
            Home
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const fcmRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={fcmObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
